module.exports = __webpack_public_path__ + "img/logo_ru.6f962469.png";